(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-dogs-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const selector = '[data-real-dogs-gallery]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function sectionsWithin(container) {
      const sections = [];
      if (container.matches && container.matches(selector)) sections.push(container);
      if (container.querySelectorAll) sections.push(...container.querySelectorAll(selector));
      return sections;
    }

    function init(root) {
      if (instances.has(root)) return;
      const rail = root.querySelector('[data-gallery-rail]');
      const prev = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      const progress = root.querySelector('[data-gallery-progress]');
      const dialog = root.querySelector('[data-gallery-dialog]');
      const largeImage = root.querySelector('[data-gallery-large-image]');
      const largeVideo = root.querySelector('[data-gallery-video-player]');
      const counter = root.querySelector('[data-gallery-count]');
      const photos = [...root.querySelectorAll('[data-gallery-photo]')];
      const listeners = new AbortController();
      const options = { signal: listeners.signal };
      let index = 0;
      let lastFocus = null;
      let frame = 0;

      function updateControls() {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const value = Math.max(0, Math.min(max, rail.scrollLeft));
        const percentage = max > 0 ? 100 * value / max : 100;
        prev.disabled = value <= 1;
        next.disabled = value >= max - 1;
        progress.disabled = max <= 1;
        progress.value = percentage;
        const start = rail.scrollWidth > 0 ? 100 * value / rail.scrollWidth : 0;
        const end = rail.scrollWidth > 0 ? Math.min(100, 100 * (value + rail.clientWidth) / rail.scrollWidth) : 100;
        progress.style.setProperty('--rdg-start', `${start}%`);
        progress.style.setProperty('--rdg-end', `${end}%`);
      }

      function scrollByPage(direction) {
        rail.scrollBy({ left: direction * rail.clientWidth * 0.8, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      function showPhoto(newIndex) {
        if (!photos.length) return;
        index = (newIndex + photos.length) % photos.length;
        const photo = photos[index];
        if (largeVideo.getAttribute('src')) {
          largeVideo.pause();
          largeVideo.removeAttribute('src');
          largeVideo.load();
        }
        if (photo.dataset.galleryKind === 'video' && photo.dataset.galleryVideo) {
          largeImage.hidden = true;
          largeVideo.hidden = false;
          largeVideo.poster = photo.dataset.galleryLarge;
          largeVideo.src = photo.dataset.galleryVideo;
          largeVideo.setAttribute('aria-label', photo.querySelector('img')?.alt || '');
        } else {
          largeVideo.hidden = true;
          largeImage.hidden = false;
          largeImage.width = Number(photo.dataset.galleryWidth) || 1800;
          largeImage.height = Number(photo.dataset.galleryHeight) || 1800;
          largeImage.src = photo.dataset.galleryLarge;
          largeImage.alt = photo.querySelector('img')?.alt || '';
        }
        counter.textContent = `${index + 1} / ${photos.length}`;
      }

      prev.addEventListener('click', () => scrollByPage(-1), options);
      next.addEventListener('click', () => scrollByPage(1), options);
      progress.addEventListener('input', () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        rail.scrollTo({ left: max * Number(progress.value) / 100, behavior: 'auto' });
      }, options);
      rail.addEventListener('scroll', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateControls);
      }, { ...options, passive: true });
      rail.addEventListener('keydown', (event) => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          scrollByPage(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      photos.forEach((photo, photoIndex) => {
        photo.addEventListener('click', () => {
          lastFocus = photo;
          showPhoto(photoIndex);
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else window.open(photo.dataset.galleryVideo || photo.dataset.galleryLarge, '_blank', 'noopener,noreferrer');
        }, options);
      });
      root.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close(), options);
      root.querySelector('[data-gallery-dialog-prev]').addEventListener('click', () => showPhoto(index - 1), options);
      root.querySelector('[data-gallery-dialog-next]').addEventListener('click', () => showPhoto(index + 1), options);
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }, options);
      dialog.addEventListener('close', () => { if (largeVideo.getAttribute('src')) { largeVideo.pause(); largeVideo.removeAttribute('src'); largeVideo.load(); } if (lastFocus) lastFocus.focus({ preventScroll: true }); }, options);
      dialog.addEventListener('keydown', (event) => {
        if (event.target === largeVideo) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showPhoto(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      const observer = 'ResizeObserver' in window ? new ResizeObserver(updateControls) : null;
      if (observer) observer.observe(rail);
      else window.addEventListener('resize', updateControls, options);
      updateControls();
      instances.set(root, () => { if (largeVideo.getAttribute('src')) { largeVideo.pause(); largeVideo.removeAttribute('src'); } listeners.abort(); if (observer) observer.disconnect(); if (frame) cancelAnimationFrame(frame); });
    }

    function initAll(container) { sectionsWithin(container).forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    else initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      sectionsWithin(event.target).forEach((root) => { const dispose = instances.get(root); if (dispose) dispose(); instances.delete(root); });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest(selector);
      const rail = root && root.querySelector('[data-gallery-rail]');
      if (rail && rail.contains(event.target)) rail.scrollTo({ left: event.target.offsetLeft, behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
